<section [ngClass]="getClasses()">
  <div aria-hidden="true" aria-live="off">
    <idp-error-tooltip
      *ngIf="focused && submitAttempt && (errorState || error)"
      [arrowPosition]="arrowPosition"
      [errorMessage]="errorMessage"
      [icon]="true"
    ></idp-error-tooltip>
  </div>
  <span
    *ngIf="focused && submitAttempt && (errorState || error)"
    aria-atomic="true"
    aria-live="polite"
    class="sr-only"
    role="alert"
  >
    {{ errorMessage }}
  </span>
  <p [attr.aria-hidden]="label ? true : false" class="idp-textarea-label">
    {{ label }}
  </p>
  <textarea
    (blur)="focused = false"
    (focusin)="focused = true"
    (keyup)="setValue($event)"
    (paste)="setValuePaste($event)"
    [(ngModel)]="value"
    [attr.aria-invalid]="errorState || error"
    [attr.aria-label]="label"
    [attr.disabled]="disabled ? true : null"
    [class.tlMaskInfo]="addtlMaskInfo"
    [ngClass]="{ '--disabled': disabled }"
    class="idp-textarea-input"
    maxlength="{{ charLimit }}"
  ></textarea>
</section>
